import { TabStrip, TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import { useState } from "react";
import LoaderContainer from "../../commons/container/LoaderContainer";
import { useGetActivitesQuery, useGetDivisionsQuery, useGetFournisseursQuery, useGetTachesQuery } from "../../redux/api/cache";
import CustomTreeView from "./CustomTreeView";


interface TreeViewFiltersProps {
    resetAllQuery: () => void;
    fournisseursChildren: any;
    divisionsChildren: any;
    tachesChildren: any;
    activitesChildren: any;
    resetData: (tacheId: number) => void
}

export default function TreeViewFilters(props: TreeViewFiltersProps) {
    const [selected, setSelected] = useState<number>(0);
    const { data: fournisseurs = [], isLoading: isFournisseursLoading, isFetching: isFournisseursFetching } = useGetFournisseursQuery();
    const { data: divisions = [], isLoading: isDivisionsLoading, isFetching: isDivisionsFetching } = useGetDivisionsQuery();
    const { data: taches = [], isLoading: isTachesLoading, isFetching: isTachesFetching } = useGetTachesQuery();
    const { data: activites = [], isLoading: isActivitesLoading, isFetching: isActivitesFetching } = useGetActivitesQuery();

    const initialCheckState = {
        ids: [],
        applyCheckIndeterminate: true,
        idField: 'checkId'
    };
    const [checkFournisseurs, setCheckFournisseurs] = useState<any>(initialCheckState);
    const [checkCategories, setCheckCategories] = useState<any>(initialCheckState);
    const [checkTaches, setCheckTaches] = useState<any>(initialCheckState);
    const [checkActivites, setCheckActivites] = useState<any>(initialCheckState);

    const handleSelect = (e: TabStripSelectEventArguments) => {
        setSelected(e.selected);
    };


    return <TabStrip keepTabsMounted={true} selected={selected} onSelect={handleSelect} className="k-h-full k-overflow-auto">
        <TabStripTab title="Fournisseurs">
            {!isFournisseursLoading && !isFournisseursFetching && (<>
                <CustomTreeView data={fournisseurs} resetAllQuery={props.resetAllQuery} children={props.fournisseursChildren} name="fournisseurs" check={checkFournisseurs} setCheck={setCheckFournisseurs} resetOtherTabs={() => { setCheckCategories(initialCheckState); setCheckTaches(initialCheckState); setCheckActivites(initialCheckState); }} />
            </>)}
            {(isFournisseursLoading || isFournisseursFetching) && (<LoaderContainer />)}
        </TabStripTab>
        <TabStripTab title="Catégories">
            {!isDivisionsLoading && !isDivisionsFetching && (<>
                <CustomTreeView data={divisions} resetAllQuery={props.resetAllQuery} children={props.divisionsChildren} name="divisions" check={checkCategories} setCheck={setCheckCategories} resetOtherTabs={() => { setCheckFournisseurs(initialCheckState); setCheckTaches(initialCheckState); setCheckActivites(initialCheckState); }} />
            </>)}
            {(isDivisionsLoading || isDivisionsFetching) && (<LoaderContainer />)}
        </TabStripTab>
        <TabStripTab title="Activités">
            {!isActivitesLoading && !isActivitesFetching && (<>
                <CustomTreeView data={activites} resetAllQuery={props.resetAllQuery} children={props.activitesChildren} name="activites" check={checkActivites} setCheck={setCheckActivites} resetOtherTabs={() => { setCheckFournisseurs(initialCheckState); setCheckCategories(initialCheckState); setCheckTaches(initialCheckState); }} />
            </>)}
            {(isActivitesLoading || isActivitesFetching) && (<LoaderContainer />)}
        </TabStripTab>
        <TabStripTab title="Tâches">
            {!isTachesLoading && !isTachesFetching && (<>
                <CustomTreeView data={taches} resetAllQuery={props.resetAllQuery} children={props.tachesChildren} name="taches" check={checkTaches} setCheck={setCheckTaches} resetOtherTabs={() => { setCheckFournisseurs(initialCheckState); setCheckCategories(initialCheckState); setCheckActivites(initialCheckState); }} resetData={props.resetData} />
            </>)}
            {(isTachesLoading || isTachesFetching) && (<LoaderContainer />)}
        </TabStripTab>
    </TabStrip>;
}